import React from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import { Flex, Icon, IconButton, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function FilterLabel({ labelName, toolTip }) {
  return (
    <Flex alignItems="center" flexFlow="row nowrap" justifyContent="flex-start" mb={2}>
      <Text color="greyScale.500" textStyle="bodyMd500">
        {labelName}
      </Text>
      {toolTip && (
        <Tooltip
          borderRadius="md"
          fontSize="xs"
          label={toolTip}
          placement="top"
        >
          <IconButton
            icon={<Icon as={BsInfoCircle} boxSize="12px" />}
            size="xs"
            variant="textGrey"
          />
        </Tooltip>
      )}
    </Flex>
  );
}

FilterLabel.propTypes = {
  labelName: PropTypes.string,
  toolTip: PropTypes.string
};

export default FilterLabel;
